<template>
  <div>
    <top-header :type="6" placeholder="未售房源一房一价" fontSize="0.32rem" />
    <div class="list_main">
      <div id="line" class="pad_top"></div>
      <div class="search_con">
        <van-search
          v-model="formData.value"
          placeholder="请输入项目名称"
          shape="round"
          @search="search"
        />
      </div>
      <div class="cover_opc" @touchmove.prevent v-show="showCover"></div>
      <div class="tab_con m_flex_box flex_jz fixed">
        <div class="inner_con">
          <p
            class="text m_flex_box flex_vc flex_hc"
            :class="tab.showArea === true ? 'active' : ''"
            @click="setTab('showArea')"
          >
            <span class="line_comp1">{{
              tabText.showArea ? tabText.showArea : "区域"
            }}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showArea">
              <p
                :class="formData.xzqh === item.xzqh_code ? 'active' : ''"
                @click="
                  setVal('xzqh', item.xzqh_code, item.xzqh_name, 'showArea')
                "
                v-for="(item, index) in xzqhArray"
                :key="index"
              >
                {{ item.xzqh_name }}
              </p>
            </div>
          </transition>
        </div>

        <div class="inner_con">
          <p
            class="text m_flex_box flex_vc flex_hc"
            :class="tab.showPrice === true ? 'active' : ''"
            @click="setTab('showPrice')"
          >
            <span class="line_comp1">{{
              tabText.showPrice ? tabText.showPrice : "价格"
            }}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="price_list inner_form" v-show="tab.showPrice">
              <div class="m_flex_box price_inner">
                <div class="left" @touchmove.prevent>
                  <p
                    :class="priceType === 1 ? 'active' : ''"
                    @click="changePrice(1)"
                  >
                    单价
                  </p>
                  <p
                    :class="priceType === 2 ? 'active' : ''"
                    @click="changePrice(2)"
                  >
                    总价
                  </p>
                </div>
                <div class="right flex-1" v-show="priceType === 1">
                  <p
                    :class="formData.price === '' ? 'active' : ''"
                    @click="setVal('price', '', '', 'showPrice')"
                  >
                    不限
                  </p>
                  <div v-show="xzqhDefault === '320300'">
                    <p
                      :class="formData.price === item.value ? 'active' : ''"
                      @click="
                        setVal('price', item.value, item.text, 'showPrice')
                      "
                      v-for="(item, index) in utilPrice"
                      :key="index"
                    >
                      {{ item.text }}
                    </p>
                  </div>

                  <div v-show="xzqhDefault !== '320300'">
                    <p
                      :class="formData.price === item.value ? 'active' : ''"
                      @click="
                        setVal('price', item.value, item.text, 'showPrice')
                      "
                      v-for="(item, index1) in utilPrice1"
                      :key="index1"
                    >
                      {{ item.text }}
                    </p>
                  </div>
                </div>
                <div class="right flex-1" v-show="priceType === 2">
                  <p
                    :class="formData.totalPrice === '' ? 'active' : ''"
                    @click="setVal('totalPrice', '', '', 'showPrice')"
                  >
                    不限
                  </p>
                  <div v-show="xzqhDefault === '320300'">
                    <p
                      :class="
                        formData.totalPrice === item.value ? 'active' : ''
                      "
                      @click="
                        setVal('totalPrice', item.value, item.text, 'showPrice')
                      "
                      v-for="(item, index) in totalPrice"
                      :key="index"
                    >
                      {{ item.text }}
                    </p>
                  </div>
                  <div v-show="xzqhDefault !== '320300'">
                    <p
                      :class="
                        formData.totalPrice === item.value ? 'active' : ''
                      "
                      @click="
                        setVal('totalPrice', item.value, item.text, 'showPrice')
                      "
                      v-for="(item, index1) in totalPrice1"
                      :key="index1"
                    >
                      {{ item.text }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="bottom_con m_flex_box flex_vc flex_jz">
                <div class="m_flex_box flex_vc">
                  <span class="tit">自定义</span>
                  <input type="number" v-model="min" /><i>-</i
                  ><input type="number" v-model="max" />
                  <p><span v-show="priceType === 2">万</span>元</p>
                </div>
                <van-button type="info" @click="priceConfirm">确定</van-button>
              </div>
            </div>
          </transition>
        </div>

        <div class="inner_con">
          <p
            class="text m_flex_box flex_vc flex_hc"
            :class="tab.showHx === true ? 'active' : ''"
            @click="setTab('showHx')"
          >
            <span class="line_comp1">{{
              tabText.showHx ? tabText.showHx : "户型"
            }}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showHx">
              <p
                :class="formData.hx === '' ? 'active' : ''"
                @click="setVal('hx', '', '', 'showHx')"
              >
                不限
              </p>
              <p
                :class="formData.hx === 1 ? 'active' : ''"
                @click="setVal('hx', 1, '一居室', 'showHx')"
              >
                一居室
              </p>
              <p
                :class="formData.hx === 2 ? 'active' : ''"
                @click="setVal('hx', 2, '二居室', 'showHx')"
              >
                二居室
              </p>
              <p
                :class="formData.hx === 3 ? 'active' : ''"
                @click="setVal('hx', 3, '三居室', 'showHx')"
              >
                三居室
              </p>
              <p
                :class="formData.hx === 4 ? 'active' : ''"
                @click="setVal('hx', 4, '四居室', 'showHx')"
              >
                四居室
              </p>
              <p
                :class="formData.hx === 5 ? 'active' : ''"
                @click="setVal('hx', 5, '五居室', 'showHx')"
              >
                五居室
              </p>
              <p
                :class="formData.hx === 6 ? 'active' : ''"
                @click="setVal('hx', 6, '五居室及以上', 'showHx')"
              >
                五居室及以上
              </p>
            </div>
          </transition>
        </div>

        <div class="inner_con">
          <p
            class="text m_flex_box flex_vc flex_hc"
            :class="tab.showType === true ? 'active' : ''"
            @click="setTab('showType')"
          >
            <span class="line_comp1">更多</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="more_list inner_form" v-show="tab.showType">
              <div class="more_con">
                <div class="row_con">
                  <h4>房屋用途</h4>
                  <div class="row_inner m_flex_box flex_vc flex_vw">
                    <span
                      :class="formData.lx === '住宅' ? 'active' : ''"
                      @click="setValB('lx', '住宅')"
                      >住宅</span
                    >
                    <span
                      :class="formData.lx === '商服' ? 'active' : ''"
                      @click="setValB('lx', '商服')"
                      >商服</span
                    >
                    <span
                      :class="formData.lx === '办公' ? 'active' : ''"
                      @click="setValB('lx', '办公')"
                      >办公</span
                    >
                    <span
                      :class="formData.lx === '仓储' ? 'active' : ''"
                      @click="setValB('lx', '仓储')"
                      >仓储</span
                    >
                    <span
                      :class="formData.lx === '车库' ? 'active' : ''"
                      @click="setValB('lx', '车库')"
                      >车库</span
                    >
                    <span
                      :class="formData.lx === '储藏室' ? 'active' : ''"
                      @click="setValB('lx', '储藏室')"
                      >储藏室</span
                    >
                    <span
                      :class="formData.lx === '地下室' ? 'active' : ''"
                      @click="setValB('lx', '地下室')"
                      >地下室</span
                    >
                  </div>
                </div>

                <div class="row_con">
                  <h4>房屋类型</h4>
                  <div class="row_inner m_flex_box flex_vc flex_vw">
                    <span
                      :class="
                        formData.houseAttribute === '商品房' ? 'active' : ''
                      "
                      @click="setValB('houseAttribute', '商品房')"
                      >商品房</span
                    >
                    <span
                      :class="
                        formData.houseAttribute === '经适房' ? 'active' : ''
                      "
                      @click="setValB('houseAttribute', '经适房')"
                      >经适房</span
                    >
                    <span
                      :class="
                        formData.houseAttribute === '定销房' ? 'active' : ''
                      "
                      @click="setValB('houseAttribute', '定销房')"
                      >定销房</span
                    >
                    <span
                      :class="
                        formData.houseAttribute === '动迁房' ? 'active' : ''
                      "
                      @click="setValB('houseAttribute', '动迁房')"
                      >动迁房</span
                    >
                  </div>
                </div>
                <div class="row_con">
                  <h4>户型</h4>
                  <div class="row_inner m_flex_box flex_vc flex_vw">
                    <span
                      :class="formData.hx === 1 ? 'active' : ''"
                      @click="setValB('hx', 1)"
                      >一居室</span
                    >
                    <span
                      :class="formData.hx === 2 ? 'active' : ''"
                      @click="setValB('hx', 2)"
                      >二居室</span
                    >
                    <span
                      :class="formData.hx === 3 ? 'active' : ''"
                      @click="setValB('hx', 3)"
                      >三居室</span
                    >
                    <span
                      :class="formData.hx === 4 ? 'active' : ''"
                      @click="setValB('hx', 4)"
                      >四居室</span
                    >
                    <span
                      :class="formData.hx === 5 ? 'active' : ''"
                      @click="setValB('hx', 5)"
                      >五居室</span
                    >
                    <span
                      :class="formData.hx === 6 ? 'active' : ''"
                      @click="setValB('hx', 6)"
                      >五室及以上</span
                    >
                  </div>
                </div>

                <div class="row_con">
                  <h4>物业类型</h4>
                  <div class="row_inner m_flex_box flex_vc flex_vw">
                    <span
                      :class="formData.structType === '多层' ? 'active' : ''"
                      @click="setValB('structType', '多层')"
                      >多层</span
                    >
                    <span
                      :class="formData.structType === '小高层' ? 'active' : ''"
                      @click="setValB('structType', '小高层')"
                      >小高层</span
                    >
                    <span
                      :class="formData.structType === '高层' ? 'active' : ''"
                      @click="setValB('structType', '高层')"
                      >高层</span
                    >
                    <span
                      :class="formData.structType === '洋房' ? 'active' : ''"
                      @click="setValB('structType', '洋房')"
                      >洋房</span
                    >
                    <span
                      :class="
                        formData.structType === '别墅叠拼' ? 'active' : ''
                      "
                      @click="setValB('structType', '别墅叠拼')"
                      >别墅叠拼</span
                    >
                    <span
                      :class="
                        formData.structType === '别墅独栋' ? 'active' : ''
                      "
                      @click="setValB('structType', '别墅独栋')"
                      >别墅独栋</span
                    >
                    <span
                      :class="
                        formData.structType === '别墅联排' ? 'active' : ''
                      "
                      @click="setValB('structType', '别墅联排')"
                      >别墅联排</span
                    >
                    <span
                      :class="
                        formData.structType === '别墅双拼' ? 'active' : ''
                      "
                      @click="setValB('structType', '别墅双拼')"
                      >别墅双拼</span
                    >
                    <span
                      :class="formData.structType === '办公' ? 'active' : ''"
                      @click="setValB('structType', '办公')"
                      >办公</span
                    >
                    <span
                      :class="formData.structType === '写字楼' ? 'active' : ''"
                      @click="setValB('structType', '写字楼')"
                      >写字楼</span
                    >
                    <span
                      :class="formData.structType === '公寓' ? 'active' : ''"
                      @click="setValB('structType', '公寓')"
                      >公寓</span
                    >
                    <span
                      :class="formData.structType === '商铺' ? 'active' : ''"
                      @click="setValB('structType', '商铺')"
                      >商铺</span
                    >
                    <span
                      :class="formData.structType === '商业' ? 'active' : ''"
                      @click="setValB('structType', '商业')"
                      >商业</span
                    >
                  </div>
                </div>
              </div>
              <div class="m_flex_box flex_vc flex_jz btn_con">
                <button class="reset" @click="reset">重置</button>
                <button class="confirm" @click="confirm">确定</button>
              </div>
            </div>
          </transition>
        </div>

        <div class="inner_con">
          <p
            class="text m_flex_box flex_vc flex_hc"
            :class="tab.showSort === true ? 'active' : ''"
            @click="setTab('showSort')"
          >
            <span class="line_comp1">{{
              tabText.showSort ? tabText.showSort : "排序"
            }}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showSort">
              <p
                :class="!formData.order ? 'active' : ''"
                @click="setVal('order', 0, '', 'showSort')"
              >
                默认排序
              </p>
              <p
                :class="formData.order === 1 ? 'active' : ''"
                @click="setVal('order', 1, '单价由低至高', 'showSort')"
              >
                单价由低至高
              </p>
              <p
                :class="formData.order === 2 ? 'active' : ''"
                @click="setVal('order', 2, '单价由高至低', 'showSort')"
              >
                单价由高至低
              </p>
              <p
                :class="formData.order === 3 ? 'active' : ''"
                @click="setVal('order', 3, '开盘时间升序', 'showSort')"
              >
                开盘时间升序
              </p>
              <p
                :class="formData.order === 4 ? 'active' : ''"
                @click="setVal('order', 4, '开盘时间降序', 'showSort')"
              >
                开盘时间降序
              </p>
              <p
                :class="formData.order === 5 ? 'active' : ''"
                @click="setVal('order', 5, '访问量', 'showSort')"
              >
                访问量
              </p>
              <p
                :class="formData.order === 6 ? 'active' : ''"
                @click="setVal('order', 6, '总价从低到高', 'showSort')"
              >
                总价从低到高
              </p>
              <p
                :class="formData.order === 7 ? 'active' : ''"
                @click="setVal('order', 7, '总价从高到低', 'showSort')"
              >
                总价从高到低
              </p>
            </div>
          </transition>
        </div>
      </div>
      <div class="main_inner">
        <div class="price_list_con">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div class="no_data" v-if="!list.length">
                <img src="@/assets/img/nodata.png" alt="" />
              </div>
              <div
                class="inner m_flex_box flex_vc flex_jz"
                v-for="(item, index) in list"
                :key="index"
                @click="toDetail(item.itemId, item.houseId)"
              >
                <div class="left">
                  <img
                    v-lazy="imgPath + 'sImgHouse/' + item.houseMapID + '.jpg'"
                    alt=""
                  />
                  <p>{{ item.hx }}</p>
                </div>
                <div class="right">
                  <div class="m_flex_box flex_vc flex_jz top">
                    <h5 class="line_comp1">{{ item.tgmc }}</h5>
                    <span>{{ item.houseState }}</span>
                  </div>
                  <img
                    :src="'data:image/png;base64,' + item.base64String"
                    class="info"
                    alt=""
                  />
                  <div class="m_flex_box flex_vc icon_con">
                    <span v-if="item.houseState !== 'null'">{{
                      item.houseState
                    }}</span>
                    <span
                      v-if="
                        item.isDecorate !== 'null' && item.isDecorate !== '-'
                      "
                      >{{ item.isDecorate }}</span
                    >
                    <span v-if="item.saleHouseUse !== 'null'">{{
                      item.saleHouseUse
                    }}</span>
                    <span v-if="item.structType !== 'null'">{{
                      item.structType
                    }}</span>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
import slideImg from "@/components/slideImg";
export default {
  name: "OneHouse",
  data() {
    return {
      utilPrice: [
        {
          value: "5000-10000",
          text: "10000元/m²以下",
        },
        {
          value: "10001-15000",
          text: "10001-15000元/m²",
        },
        {
          value: "15001-17000",
          text: "15001-17000元/m²",
        },
        {
          value: "17001-20000",
          text: "17001-20000元/m²",
        },
        {
          value: "20001-25000",
          text: "20001-25000元/m²",
        },
        {
          value: "25001-30000",
          text: "25001-30000元/m²",
        },
        {
          value: "30001-50000",
          text: "30001元/m²以上",
        },
      ],
      utilPrice1: [
        {
          value: "1000-5000",
          text: "5000元/m²以下",
        },
        {
          value: "5001-6000",
          text: "5001-6000元/m²",
        },
        {
          value: "6001-7000",
          text: "6001-7000元/m²",
        },
        {
          value: "7001-8000",
          text: "7001-8000元/m²",
        },
        {
          value: "8001-9000",
          text: "8001-9000元/m²",
        },
        {
          value: "9001-10000",
          text: "9001-10000元/m²",
        },
        {
          value: "10001-20000",
          text: "10000元/m²以上",
        },
      ],
      totalPrice: [
        {
          value: "100000-1000000",
          text: "100万以下",
        },
        {
          value: "1000000-1500000",
          text: "100-150万元",
        },
        {
          value: "1510000-2000000",
          text: "151-200万元",
        },
        {
          value: "2010000-2500000",
          text: "201-250万元",
        },
        {
          value: "2510000-3000000",
          text: "251-300万元",
        },
        {
          value: "3010000-4000000",
          text: "301-400万元",
        },
        {
          value: "4000000-100000000",
          text: "400万以上",
        },
      ],
      totalPrice1: [
        {
          value: "10000-500000",
          text: "50万以下",
        },
        {
          value: "510000-700000",
          text: "51-70万元",
        },
        {
          value: "710000-800000",
          text: "71-80万元",
        },
        {
          value: "810000-900000",
          text: "81-90万元",
        },
        {
          value: "910000-1000000",
          text: "91-100万元",
        },
        {
          value: "1010000-1200000",
          text: "101-120万元",
        },
        {
          value: "1200000-5000000",
          text: "120万以上",
        },
      ],
      tab: {
        showArea: false,
        showPrice: false,
        showHx: false,
        showType: false,
        showSort: false,
      },
      tabText: {
        showArea: "",
        showPrice: "",
        showHx: "",
        showSort: "",
      },
      priceType: 1,
      formData: {
        value: "",
        xzqh: this.main.getHostArea(),
        mc: "",
        order: 0,
        type: 2,
        price: "",
        totalPrice: "",
        xsjgq: "",
        xsjgz: "",
        zjgq: "",
        zjgz: "",
        xsqk: "",
        yssj: "",
        hx: "",
        lx: "",
        houseAttribute: "",
        structType: "",
      },
      min: "",
      max: "",
      showPad: false,
      showCover: false,
      listPage: 1,
      isLoading: false,
      loading: false,
      finished: false,
      xzqhDefault: this.main.getHostArea(),
      xzqhArray: [],
      list: [],
      timer: null,
    };
  },
  components: {
    topHeader,
    slideImg,
  },
  mounted() {
    this.getArea();
  },
  methods: {
    // 获取默认的行政区划
    getArea() {
      this.$new.post("xzqh/getXzqh.do").then((res) => {
        if (res.obj) {
          if (this.xzqhDefault === "320300") {
            this.xzqhArray = res.obj[0].xzqhs;
            this.items = { xzqh_code: "320300", xzqh_name: "不限" };
            this.xzqhArray.splice(0, 0, this.items);
          } else {
            res.obj.forEach((item) => {
              if (this.xzqhDefault === item.xzqh_code) {
                this.$set(this, "xzqhArray", [item]);
              }
            });
          }
        }
      });
    },
    toDetail(itemId, houseId) {
      this.$router.push({
        path: "/oneHouseOnePriceDetail",
        query: { itemId, houseId },
      });
    },
    search() {
      this.$set(this, "listPage", 1);
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.onLoad();
    },
    onRefresh() {
      this.$set(this, "listPage", 1);
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.onLoad(1);
    },
    onLoad(type) {
      var that = this;
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        that.$new
              .post(
                "houseApi/getHouseList.do",
                qs.stringify({
                  pageSize: 10,
                  currPageNo: that.listPage,
                  type: 2,
                  order: that.formData.order,
                  xzqh: that.formData.xzqh,
                  mc: that.formData.value,
                  //yssj: this.formData.yssj,
                  lx: that.formData.lx,
                  //xsqk: this.formData.xsqk,
                  structType: that.formData.structType,
                  xsjgq: that.formData.xsjgq,
                  xsjgz: that.formData.xsjgz,
                  zjgq: that.formData.zjgq,
                  zjgz: that.formData.zjgz,
                  hx: that.formData.hx,
                  houseAttribute: that.formData.houseAttribute,
                })
              )
              .then((res) => {
                if (type) {
                  that.isLoading = false;
                }
                if (res.success) {
                  that.list = that.list.concat(res.obj);
                  that.loading = false;
                  that.listPage += 1;
                } else {
                  that.finished = true;
                }
              });
      }
    },

    setTab(type) {
      this.showPad = true;
      this.$nextTick(() => {
        document.getElementById("line").scrollIntoView();
      });
      for (let key in this.tab) {
        if (type === key) {
          this.$set(this.tab, type, !this.tab[type]);
        } else {
          this.$set(this.tab, key, false);
        }
        if (this.tab[type]) {
          this.showCover = true;
        } else {
          this.showCover = false;
        }
      }
    },
    setVal(type, v, t, tab) {
      this.$set(this.formData, type, v);
      if (type === "totalPrice") {
        this.$set(this.formData, "zjgq", v.split("-")[0]);
        this.$set(this.formData, "zjgz", v.split("-")[1]);
      } else if (type === "price") {
        this.$set(this.formData, "xsjgq", v.split("-")[0]);
        this.$set(this.formData, "xsjgz", v.split("-")[1]);
      }
      if (tab) {
        this.$set(this.tab, tab, false);
        this.$set(this.tabText, tab, t);
        this.showCover = false;
      }
      this.$set(this, "listPage", 1);
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.onLoad();
    },
    setValB(type, v) {
      if (this.formData[type] === v) {
        this.$set(this.formData, type, "");
      } else {
        this.$set(this.formData, type, v);
      }
    },
    reset() {
      this.$set(this.formData, "lx", "");
      this.$set(this.formData, "yssj", "");
      this.$set(this.formData, "xsqk", "");
      this.$set(this.formData, "structType", "");
      this.$set(this.formData, "hx", "");
      this.$set(this.formData, "houseAttribute", "");

      this.$set(this.tab, "showType", false);
      this.showCover = false;

      this.$set(this, "listPage", 1);
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.onLoad();
    },
    confirm() {
      this.$set(this.tab, "showType", false);
      this.showCover = false;

      this.$set(this, "listPage", 1);
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.onLoad();
    },
    // 价格判断
    priceConfirm() {
      if (this.min && this.max) {
        if (this.min > this.max) {
          if (this.priceType === 1) {
            this.$set(this.formData, "xsjgq", this.max);
            this.$set(this.formData, "xsjgz", this.min);
            this.min = this.formData.xsjgq;
            this.max = this.formData.xsjgz;
          } else {
            this.$set(this.formData, "zjgq", this.max * 10000);
            this.$set(this.formData, "zjgz", this.min * 10000);
            this.min = this.formData.zjgq / 10000;
            this.max = this.formData.zjgz / 10000;
          }
        } else {
          if (this.priceType === 1) {
            this.$set(this.formData, "xsjgz", this.max);
            this.$set(this.formData, "xsjgq", this.min);
            this.min = this.formData.xsjgq;
            this.max = this.formData.xsjgz;
          } else {
            this.$set(this.formData, "zjgz", this.max * 10000);
            this.$set(this.formData, "zjgq", this.min * 10000);
            this.min = this.formData.zjgq / 10000;
            this.max = this.formData.zjgz / 10000;
          }
        }
        this.$set(this, "listPage", 1);
        this.loading = false;
        this.finished = false;
        this.list = [];
        this.onLoad();
        if (this.priceType === 1) {
          this.$set(
            this.tabText,
            "showPrice",
            this.min + "-" + this.max + "万元"
          );
        } else {
          this.$set(
            this.tabText,
            "showPrice",
            this.min + "-" + this.max + "万元"
          );
        }
      }
      this.$set(this.tab, "showPrice", false);
      this.showCover = false;
    },
    changePrice(type) {
      this.priceType = type;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "OneHouseOnePriceDetail") {
      this.$store.dispatch("saveView", ["OneHouse"]).then(() => {
        next();
      });
    } else {
      this.$store.dispatch("saveView", []).then(() => {
        next();
      });
    }
  },
};
</script>
<style lang="less" scoped>
.overLy {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.main_inner {
  width: 7.04rem;
  margin: 0 auto;
  display: block;
}
.tit {
  margin-right: 0.2rem;
}
.info {
  color: #505050;
  font-size: 0.24rem;
  p {
    margin-right: 0.2rem;
  }
  span {
    color: #ff6a18;
  }
}
.price_list {
  .price_inner {
    height: 5.92rem;
  }
  .left {
    border-right: 1px solid #f4f4f4;
    width: 45%;
  }
  .right {
    box-sizing: border-box;
    padding-left: 0.2rem;
    max-height: 5.92rem;
    overflow: auto;
  }
  p {
    line-height: 0.99rem;
    box-sizing: border-box;
    border-bottom: 1px solid #f4f4f4;
    text-align: center;
    &:last-child {
      border: none;
    }
    &.active {
      color: #2f72f5;
    }
  }
  .bottom_con {
    height: 1.2rem;
    box-sizing: border-box;
    border-top: 1px solid #f4f4f4;
    padding: 0 0.3rem;
    input {
      width: 1.38rem;
      height: 0.78rem;
      border: 1px solid #f4f4f4;
      text-align: center;
    }
    .tit {
      margin-right: 0.2rem;
    }
    i {
      margin: 0.1rem;
    }
    p {
      margin-left: 0.2rem;
    }
    .van-button {
      height: 0.78rem;
    }
  }
}
.more_list {
  padding: 0 0.3rem 0;
  h4 {
    font-size: 0.3rem;
    margin-bottom: 0.3rem;
  }
  .more_con {
    padding-top: 0.46rem;
    height: 5.92rem;
    overflow: auto;
    box-sizing: border-box;
  }
  .btn_con {
    height: 1.2rem;
    box-sizing: border-box;
    border-top: 1px solid #f4f4f4;
    button {
      width: 3.3rem;
      line-height: 0.8rem;
      font-size: 0.28rem;
      border-radius: 0.02rem;
      &.reset {
        background-color: #eaf1ff;
        color: #2f72f5;
      }
      &.confirm {
        background-color: #2f72f5;
        color: #fff;
      }
    }
  }
  .row_con {
    margin-bottom: 0.54rem;
  }
  span {
    background-color: #f6f6f6;
    line-height: 0.66rem;
    width: 1.62rem;
    margin-right: 0.12rem;
    border-radius: 0.02rem;
    text-align: center;
    margin-bottom: 0.12rem;
    box-sizing: border-box;
    border: 1px solid #f6f6f6;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &.active {
      color: #2f72f5;
      background-color: #eaf1ff;
      border: 1px solid #2f72f5;
    }
  }
}
.list_main {
  background-color: #fff;
  h4 {
    font-size: 0.38rem;
    margin: 0rem 0 0.2rem;
    font-weight: 600;
    padding: 0 0.28rem;
  }
  .tab_con {
    padding: 0 0.16rem;
    font-size: 0.28rem;
    position: relative;
    border-bottom: 1px solid #e9e9e9;
    z-index: 2;
    background-color: #fff;
    &.fixed {
      position: fixed;
      top: calc(0.9rem + 44px);
      left: 0;
      right: 0;
      border-top: 1px solid #e9e9e9;
    }
    .inner_con {
      .text {
        padding: 0.2rem 0rem;
        text-align: center;
        width: 1.2rem;
        .van-icon {
          transition: all 0.3s;
          color: #cecece;
          transform: rotate(90deg);
          margin-left: 0.06rem;
          font-size: 0.2rem;
        }
        &.active {
          color: #2f72f5;
          .van-icon {
            transform: rotate(-90deg);
            color: #2f72f5;
          }
        }
      }
      .inner_form {
        background-color: #fff;
        position: absolute;
        left: 0;
        right: 0;
        top: calc(100% + 0.02rem);
        max-height: 7.12rem;
        overflow: auto;
      }
      .inner_list {
        padding: 0 0.5rem;
        p {
          line-height: 0.99rem;
          box-sizing: border-box;
          border-bottom: 1px solid #f4f4f4;
          text-align: center;
          &:last-child {
            border: none;
          }
          &.active {
            color: #2f72f5;
          }
        }
      }
    }
  }
}
.search_con {
  position: fixed;
  background-color: #fff;
  left: 0;
  right: 0;
  top: 0.9rem;
  z-index: 10;
}
.pad_top {
  padding-top: calc(0.82rem + 44px);
}
/deep/ .van-search {
  padding-top: 0;
}
.price_list_con {
  min-height: 80%;
  .inner {
    padding: 0.3rem 0;
    border-bottom: 1px solid #f4f4f4;
    &:last-child {
      padding: 0.3rem 0 0;
      border-bottom: 0;
    }
    .left {
      width: 1.94rem;
      img {
        width: 100%;
        height: 1.86rem;
        border: 1px solid #dcdcdc;
        border-bottom: 0;
        display: block;
        box-sizing: border-box;
      }
      p {
        color: #fff;
        background-color: #ff472e;
        font-size: 0.22rem;
        padding: 0.04rem;
        text-align: center;
      }
    }
    .right {
      width: 4.84rem;
      img {
        width: 100%;
      }
      .top {
        position: relative;
        top: -0.04rem;
        h5 {
          font-size: 0.3rem;
          margin-bottom: 0.12rem;
          max-width: 80%;
        }
        span {
          font-size: 0.22rem;
          color: #3072f5;
          border: 1px solid currentColor;
          padding: 0.02rem 0.06rem;
          border-radius: 0.04rem;
        }
      }
      .icon_con {
        margin-top: 0.08rem;
        span {
          padding: 0.04rem 0.06rem;
          color: #6c6d71;
          font-size: 0.22rem;
          background-color: #eef1f6;
          border-radius: 0.04rem;
          margin-right: 0.12rem;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
